<template>
    <div  class="p-5-9">
        <div>
            <div >收款公司</div>
            <el-select v-model="i_gsid" size="mini" @change="chooseSkFun" style="width: 100%">
                <el-option v-for="item in skList" :key="item.i_id" :label="item.vc_name" :value="item.i_id"></el-option>
            </el-select>
        </div>
        <div class="rightBorder ">
            <div >付款方</div>
            <div class="flex">
                <el-input class="mr9" v-model="search" placeholder="搜索" size="mini" @change="searchFun">
                    <el-button  slot="append" icon="el-icon-search"  size="mini" @click="searchFun" ></el-button>
                </el-input>
                <el-button @click="allFun" size="mini" plain>全部</el-button>
            </div>

            <div :class="baseerp+'div'"  :style="{height: tableHeight+'px',overflowY: 'auto',paddingTop:'6px'}">
<!--                <el-tooltip></el-tooltip>-->
                <div :class="['fkbox flex' ,item.i_id==i_khid?'active':'']" v-for="(item,index) in fkList" @click="chooseFkFun(item)">
                    <i class="el-icon-collection-tag" ></i>
                    <div>{{item.vc_name}}</div>
                </div>
            </div>
            <el-pagination  style="margin-top: 10px;text-align: right"

                            small
                            @current-change="pageCurrentChange"
                            layout="prev, pager, next"
                            :current-page.sync="currentPage"
                            :total="total"
                            :page-size="pageSize">
            </el-pagination>
        </div>
    </div>
</template>

<script>
    import * as API from "./api"
    import {baseerp} from "@/utils/baseUrl";

    export default {
        name: "KhList",
        components: {},
        data() {
            return {
                baseerp:'',
                skList:[],
                fkList:[],
                i_gsid:0,
                i_khid:null,
                vc_gsname:'',
                vc_khname:'',
                search:'',
                currentPage: 1,
                pageSize: 15,
                total:0,
                tableHeight:0,
            }
        },
        watch: {

            '$root.workSize':{
                handler(n,o) {
                    this.onResize(n);
                },
                deep:true,
            },
        },
        activated(){
            this.onResize();
        },
        mounted() {
            this.getCompanyList()
            this.getCustomers()
            this.baseerp=baseerp
            this.$nextTick(()=>{
                this.onResize();

            })

        },
        methods: {
            onResize (n){
                if (n==undefined) n=this.$root.workSize;

                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight= n.h-200

            },
            searchFun(){
                this.currentPage=1
                this.getCustomers()
            },
            allFun(){
                this.i_khid=null
                this.vc_khname='全部'
                this.currentPage=1
                this.search=''
                this.getCustomers()
                let data={
                    i_gsid:this.i_gsid,
                    i_khid:null,
                    vc_khname:'全部',
                    vc_gsname:this.vc_gsname,
                };
                this.$emit('click',data)

            },
            chooseFkFun(item){
                this.i_khid=item.i_id
                this.vc_khname=item.vc_name
                let data={
                    i_gsid:this.i_gsid,
                    i_khid:this.i_khid,
                    vc_khname:this.vc_khname,
                    vc_gsname:this.vc_gsname,
                };
                this.$emit('click',data)
            },
            chooseSkFun(val){
                let obj=this.skList.find(o=>o.i_id==val);
                if(obj!==undefined){
                    this.vc_gsname=obj.vc_name;
                }
                let data={
                    i_gsid:this.i_gsid,
                    i_khid:this.i_khid,
                    vc_khname:this.vc_khname,
                    vc_gsname:this.vc_gsname,
                };
                this.$emit('click',data)

            },
            pageCurrentChange(val){
                // console.log(val,"pageval");
                this.currentPage=val;
                //调用列表接口
                this.getCustomers();
            },
            async getCompanyList(){
                let param={
                    i_type:'0,2'
                };
                let res=await API.getCompanyList(param);
                if ( res.code == 1 ){
                    this.skList=res.data;
                    if(this.skList.length>0){
                        this.i_gsid=this.skList[0].i_id
                        this.vc_gsname=this.skList[0].vc_name
                        this.allFun()
                    }

                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            async getCustomers(){
                let param={
                    currentPage:this.currentPage,
                    pageSize:this.pageSize,
                    vc_name:this.search
                };
                let res=await API.getCustomers(param);
                if ( res.code == 1 ){
                    this.fkList=res.data
                    this.total=res.total;

                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },

        },
    }
</script>

<style lang="scss" scoped>
    .flex{
        display: flex;

    }
    div{
        font-size: 12px;
        line-height: 1.5;
    }
    .ghwdiv{
        .active{
            background-color: var(--opacityghw);
        }
        i{
            color: var(--darkghw);
            padding-top: 3px;
            padding-right: 6px;
        }
    }
    .havaydiv{
        .active{
            background-color: var(--opacityhavay);
        }
        i{
            color: var(--darkhavay);
            padding-top: 3px;
            padding-right: 6px;
        }
    }
    .fkbox{
        padding: 5px 9px;
        cursor: pointer;
    }
    .p-5-9{
        padding: 5px 9px;

    }
    .rightBorder{
        margin-top: 5px;
        /*border-right: 1px solid #a0a0a0;*/
    }
    .mr9{
        margin-right: 8px;
    }
</style>